import type { ProcurementAmendabilityReason } from '~/api/k2/typedefs.autogen';

import { everest } from '~/services/serviceInstances';

interface GetEverestAmendabilityParams {
  contractRecordUniqueId: string;
}

export interface EverestAmendabilityResponse {
  contract_record_unique_id: string;
  is_amendable: boolean;
  reason: ProcurementAmendabilityReason | null;
}

export const getEverestAmendability = async ({
  contractRecordUniqueId,
}: GetEverestAmendabilityParams): Promise<EverestAmendabilityResponse> =>
  everest.get('/integrate-workflow/amendability', {
    params: { contract_record_unique_id: contractRecordUniqueId },
  });
